export default __webpack_public_path__ + "static/media/duitnow.37c39c82.svg";